import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#2C5E3B] to-[#1C3F26] flex items-center justify-center">
      <div className="relative">
        {/* Animated Growing Tree Concept */}
        <div className="w-64 h-64 relative">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 100 100" 
            className="absolute inset-0"
          >
            {/* Tree Trunk */}
            <rect 
              x="48" 
              y="70" 
              width="4" 
              height="20" 
              fill="#8B4513" 
              className="origin-bottom animate-grow-trunk"
            />

            {/* Branches Growing */}
            <path 
              d="M50 50 L40 60 L30 50" 
              stroke="#2E7D32" 
              strokeWidth="3" 
              fill="none" 
              className="origin-bottom animate-grow-branch-left"
            />
            <path 
              d="M50 50 L60 60 L70 50" 
              stroke="#2E7D32" 
              strokeWidth="3" 
              fill="none" 
              className="origin-bottom animate-grow-branch-right"
            />

            {/* Leaf Clusters */}
            <circle 
              cx="30" 
              cy="45" 
              r="8" 
              fill="#4CAF50" 
              className="animate-pulse-leaves"
            />
            <circle 
              cx="70" 
              cy="45" 
              r="8" 
              fill="#4CAF50" 
              className="animate-pulse-leaves delay-200"
            />
            <circle 
              cx="50" 
              cy="35" 
              r="10" 
              fill="#2E7D32" 
              className="animate-pulse-leaves delay-100"
            />
          </svg>
        </div>

        {/* Loading text */}
        <div className="mt-8 text-center">
          <div className="text-green-200 font-semibold text-xl">Growing Solution</div>
          <div className="flex justify-center mt-2 space-x-1">
            {[0, 1, 2].map((dot) => (
              <div
                key={dot}
                className="w-2 h-2 bg-green-300 rounded-full animate-bounce"
                style={{
                  animationDelay: `${dot * 0.2}s`,
                  animationDuration: '1s'
                }}
              ></div>
            ))}
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute -top-12 -left-12 w-24 h-24 bg-green-500/10 rounded-full blur-xl"></div>
        <div className="absolute -bottom-8 -right-8 w-16 h-16 bg-green-500/10 rounded-full blur-lg"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;